// inits/jquery
// Anything we need to do to JQuery globally

import $ from 'jquery';
import Radio from 'backbone.radio';

    var apiCh = Radio.channel('api');
    function ajax_start() {
        apiCh.trigger('ajax_start');
    }
    function ajax_stop() {
        apiCh.trigger('ajax_stop');
    }
    
    export default function(){
        $(document).ajaxStart(ajax_start);
        $(document).ajaxStop(ajax_stop);
        // Found we have a bug where a 200 response with no data throws 
        // jquery, and in turn Backbone, for a loop.
        // http://jquery.com/upgrade-guide/1.9/#jquery-ajax-returning-a-json-result-of-an-empty-string
        // http://stackoverflow.com/questions/14468704/what-changed-in-jquery-1-9-to-cause-a-ajax-call-to-fail-with-syntax-error
        $.ajaxSetup({dataFilter: function(data, type) {
            if (type == "json" && data === "") {
                data = null;
            }
            return data;
        }});

        // Add resizeTo to resizable. This allows us to programatically
        // manipulate elements which have had the resizable UI widget 
        // applied rather than relying on direct UI interaction (i.e.
        // mouse click+drag). 
        $.widget("ui.resizable", $.ui.resizable, {
            resizeTo: function(newSize) {
                var start = new $.Event('mousedown', { pageX: 0, pageY: 0 });
                this._mouseStart(start);
                this.axis = 'se';
                var end = new $.Event('mouseup', {
                    pageX: newSize.width - this.originalSize.width,
                    pageY: newSize.height - this.originalSize.height
                });
                this._mouseDrag(end);
                this._mouseStop(end);
            }
        });
    }

